export default __webpack_public_path__ + "static/media/Frame 2.834b9eb7.svg";